/**
 * ⭐ What build this is — two different questions (owner, 2026-10-04).
 *
 * - `PRODUCT_VERSION`: the five-level version from `version.json` (Main.Major.Minor.
 *   Subminor.Trivial — rules in `utils/releaseVersion.ts`, bumped with `npm run release`).
 *   Shown to users under the logo as "BETA v0.7.0.0.0".
 * - `BUILD_ID`: the commit (Netlify's `COMMIT_REF`, else local git, else `dev`).
 *   Changes on every merge; feedback rows are stamped with it (`app_version`).
 *
 * Both are injected by `vite.config.ts` `define`. Under vitest neither is defined,
 * so both fall back to `''` — a component must render sensibly without them.
 */
const env = (import.meta as unknown as { env?: Record<string, string | undefined> }).env ?? {};

export const PRODUCT_VERSION: string = env.VITE_PRODUCT_VERSION ?? '';
export const BUILD_ID: string = env.VITE_APP_VERSION ?? '';

/** "v0.7.0.0.0", or '' when no version was injected. */
export const versionLabel = (version: string = PRODUCT_VERSION): string => (version ? `v${version}` : '');
